export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (e) {
    console.log('Could not save state');
  }
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }

    const serialized = JSON.parse(serializedState);

    return {
      login: {
        authInfo: serialized.login.authInfo,
        isLogining: false,
        error: null
      }
    };
  } catch (e) {
    return undefined;
  }
};